import { useState } from 'react';
import { Modal, notification, Pagination, Table } from 'antd';

import { Button, DotBtn } from 'components';
import { useHooks, useDebounce, usePost } from 'hooks';
import Container from 'modules/container';
// import UpdateCategory from './update';
import { utils } from 'services';

const Condidates = () => {
  const { t, qs, get, location, queryClient } = useHooks();
  const { mutate } = usePost();
  const [page, setPage] = useState<number>(1);
  const [query, setQuery] = useState('');
  const searchQuery = useDebounce(query, 600);
  // const [createCondidates, openCreateCondidates] = useState<any>({
  //   data: null,
  //   open: false,
  // });

  const params = qs.parse(location.search, { ignoreQueryPrefix: true });

  const onDeleteHandlerCondidates = (row: any) => {
    const id = get(row, '_id');
    Modal.confirm({
      title: t("Kondidatnini o'chirishni tasdiqlaysizmi") + '?',
      cancelText: t("yo'q"),
      okType: 'primary',
      okText: t('ha'),
      onOk: () => deleteActionCategory(id),
    });
  };

  const deleteActionCategory = (id: any) => {
    if (id) {
      mutate(
        { method: 'delete', url: `condidates/${id}`, data: null },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: [`condidates`],
            });

            notification['success']({
              message: t('Успешно удален!'),
              duration: 2,
            });
          },
          onError: (error: any) => {
            notification['error']({
              message: t(
                get(error, 'response.data.error', 'Произошло ошибка!')
              ),
              duration: get(error, 'response.data.message') ? 4 : 2,
            });
          },
        }
      );
    }
  };

  return (
    <>
      {/* <Modal
        open={get(createCondidates, 'open')}
        onOk={() => openCreateCondidates({ open: true, data: null })}
        onCancel={() => openCreateCondidates({ open: false, data: null })}
        footer={null}
        centered
        title={
          get(createCondidates, 'data')
            ? t('Kondidatni tahrirlash')
            : t("Kondidatni qo'shish")
        }
        width={400}
        destroyOnClose
      > */}
        {/* <UpdateCategory {...{ createCondidates, openCreateCondidates }} /> */}
      {/* </Modal> */}
      <div className="content-panel">
        <div>
          <Container.All
            url="condidates"
            name="condidates"
            params={{
              limit: 15,
              page,
              extra: {
                search: searchQuery,
                start: params.start && params.start,
                end: params.end && params.end,
              },
            }}
          >
            {({ meta, items }) => {
              return (
                <div>
                  <div className="page-heading">
                    <p className="page-heading__title">
                      {t('Kondidatlar')}
                      <p className="page-heading__subtitle">
                        {t('Kondidatlar soni')}: {get(meta, 'totalCount')}
                      </p>
                    </p>
                    {/* <div className="page-heading__right">
                      <Button
                        type="primary"
                        title="Qo'shish"
                        create
                        onClick={() =>
                          openCreateCondidates({ open: true, data: null })
                        }
                      />
                    </div> */}
                  </div>
                  <Table
                    dataSource={items}
                    pagination={false}
                    columns={[
                      {
                        key: 'id',
                        title: t('№'),
                        align: 'left',
                        dataIndex: '_id',
                        className: 'w-[20px]',
                        render: (value) => <>{value}</>,
                      },
                      {
                        key: 'fullName',
                        align: 'left',
                        title: t('Ism familiyasi'),
                        dataIndex: 'color',
                        className: 'w-[200px]',
                        render: (value, row) => (
                          <div className="flex items-center gap-2">
                            {get(row, 'fullName')}
                          </div>
                        ),
                      },
                      {
                        key: 'phoneNumber',
                        align: 'left',
                        title: t('Telefon raqami'),
                        dataIndex: 'color',
                        className: 'w-[200px]',
                        render: (value, row) => (
                          <div className="flex items-center gap-2">                           
                            {get(row, 'phoneNumber')}
                          </div>
                        ),
                      },
                      {
                        key: 'vacancy.titleUz',
                        align: 'left',
                        title: t('Vakansiya'),
                        dataIndex: 'color',
                        className: 'w-[200px]',
                        render: (value, row) => (
                          <div className="flex items-center gap-2">                           
                            {get(row, 'vacancy.titleUz')}
                          </div>
                        ),
                      },
                      {
                        key: 'vacancy.descriptionUz',
                        align: 'left',
                        title: t('Vakansiya tavsifi'),
                        dataIndex: 'color',
                        className: 'w-[300px]',
                        render: (value, row) => (
                          <div className="flex items-center gap-2">                           
                            {utils.truncateWords(get(row, 'vacancy.descriptionUz',""), 20)}
                          </div>
                        ),
                      },
                      {
                        key: 'cv',
                        align: 'left',
                        title: t('Resumeni ko`rish'),
                        dataIndex: 'color',
                        className: 'w-[200px]',
                        render: (value, row) => (
                          <div className="flex items-center gap-2">
                            <a
                              className="w-[100px] h-[46px] border-[2px] border-secondary rounded-lg p-3"
                              href={get(row, 'cv.url')}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {t('CV yuklash')}
                            </a>
                            {/* {get(row, 'cv')} */}
                          </div>
                        ),
                      },
                      {
                        title: t('Amallar'),
                        align: 'center',
                        className: 'w-[1px]',
                        render: (value, row) => (
                          <DotBtn
                            row={row}
                            // editFunction={() =>
                            //   openCreateCondidates({ open: true, data: row })
                            // }
                            deleteFunction={() => onDeleteHandlerCondidates(row)}
                          />
                        ),
                      },
                    ]}
                  />
                  {meta && meta.perPage && (
                    <div className="pt-[20px] flex justify-end">
                      <Pagination
                        current={meta.currentPage}
                        pageSize={meta.perPage}
                        total={meta.totalCount}
                        onChange={setPage}
                      />
                    </div>
                  )}
                </div>
              );
            }}
          </Container.All>
        </div>
      </div>
    </>
  );
};

export default Condidates;
